// extracted by mini-css-extract-plugin
export default {"wrapper":"On-z","response":"Pn-z","error":"Qn-z","disabled":"Rn-z","buttons":"Sn-z","feedbackQuestionSection":"Tn-z","yesNoWrapper":"Un-z"};